import Modal from "@/components/common/Modal";

interface ContractModalProps {
  open: boolean;
  onClose: () => void;
}

const ContractModal = ({ open, onClose }: ContractModalProps) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      size="lg"
      bodyClassName="max-h-[70vh] space-y-6 overflow-y-auto pr-2"
      hideCloseButton
    >
      <h5 className="px-4 py-2 rounded-full bg-gradient-to-r from-[#1BD3CC] to-[#2A51D6] text-white font-bold text-sm w-fit mx-auto">
        利用規約
      </h5>
      <span className="text-sm font-medium text-text-muted">2025年4月1日制定</span>
      <p className="text-sm leading-relaxed text-text-main">
        本規約は、BrightKids株式会社（以下、当社）が提供する「STUDICT」（以下、当サービス）の利用に関する条件を、当サービスを利用するお客様と当社の間で定めるものです。
      </p>
      <ul className="space-y-6 text-left text-sm leading-relaxed text-text-main/80">
        <li className="space-y-2">
          <h3 className="font-semibold text-primary">第1条 本規約への同意</h3>
          <p>
            〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇
          </p>
        </li>
        <li className="space-y-2">
          <h3 className="font-semibold text-primary">第2条 〇〇〇〇〇〇〇〇〇〇〇〇</h3>
          <p>
            〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇
          </p>
        </li>
        <li className="space-y-2">
          <h3 className="font-semibold text-primary">第3条 〇〇〇〇〇〇〇〇〇〇〇〇</h3>
          <p>
            〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇
          </p>
        </li>
        <li className="space-y-2">
          <h3 className="font-semibold text-primary">第4条 〇〇〇〇〇〇〇〇〇〇〇〇</h3>
          <p>
            〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇
          </p>
        </li>
        <li className="space-y-2">
          <h3 className="font-semibold text-primary">第1条 本規約への同意</h3>
          <p>
            〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇
          </p>
        </li>
        <li className="space-y-2">
          <h3 className="font-semibold text-primary">第2条 〇〇〇〇〇〇〇〇〇〇〇〇</h3>
          <p>
            〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇
          </p>
        </li>
        <li className="space-y-2">
          <h3 className="font-semibold text-primary">第3条 〇〇〇〇〇〇〇〇〇〇〇〇</h3>
          <p>
            〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇
          </p>
        </li>
        <li className="space-y-2">
          <h3 className="font-semibold text-primary">第4条 〇〇〇〇〇〇〇〇〇〇〇〇</h3>
          <p>
            〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇
          </p>
        </li>
        <li className="space-y-2">
          <h3 className="font-semibold text-primary">第1条 本規約への同意</h3>
          <p>
            〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇
          </p>
        </li>
        <li className="space-y-2">
          <h3 className="font-semibold text-primary">第2条 〇〇〇〇〇〇〇〇〇〇〇〇</h3>
          <p>
            〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇
          </p>
        </li>
        <li className="space-y-2">
          <h3 className="font-semibold text-primary">第3条 〇〇〇〇〇〇〇〇〇〇〇〇</h3>
          <p>
            〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇
          </p>
        </li>
        <li className="space-y-2">
          <h3 className="font-semibold text-primary">第4条 〇〇〇〇〇〇〇〇〇〇〇〇</h3>
          <p>
            〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇
          </p>
        </li>
      </ul>
    </Modal>
  );
};

export default ContractModal;
